import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// The Google tag only auto-tracks the first page load. On every SPA route
// change we push an event so the matching GA4 page_view tag in GTM can fire.
export default function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'spa_page_view',
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}
